export default {
    common: {
      querySpecifications: 'Τεχνικές προδιαγραφές ερωτήματος',
      login: 'Σύνδεση',
      logout: 'Αποσύνδεση',
      Home: 'Αρχική σελίδα',
      ProductCenter: 'Κέντρο προϊόντων',
      WhatIsaSoftwareDefinedCamera: 'Τι είναι μια κάμερα οριζόμενη από λογισμικό',
      ProductDetail: 'Λεπτομέρειες προϊόντος',
      Solutions: 'Λύσεις',
      SolutionsDetail: 'Λεπτομέρειες λύσεων',
      Products: 'Προϊόντα',
      Tools: 'Εργαλεία',
      Support: 'Υποστήριξη',
      Documentation: 'Τεκμηρίωση',
      news: 'Κέντρο ειδήσεων',
      newsDetail: 'Λεπτομέρειες ειδήσεων',
      forPartners: 'Για τους συνεργάτες',
      activity:'Δραστηριότητα',
      SoftwareDefinedCamera: 'Κάμερα οριζόμενη από λογισμικό',
      IntelligentVisionSystem: 'IVS',
      Accessory: 'Παρελκόμενο',
      ContactUs: 'Επικοινωνήστε μαζί μας',
      NewsRoom: 'Αίθουσα σύνταξης',
      NewsRoomDetail: 'Λεπτομέρεια αίθουσας σύνταξης',
      Partner: 'Συνεργάτης',
      Resources: 'Πόροι',
      ResourceCenter: 'Κέντρο πόρων',
      VideoLibrary: 'Βιβλιοθήκη βίντεο',
      AftersalesSupport: 'Υποστήριξη μετά την πώληση',
      Aftersales: 'Ερωτήσεις και απαντήσεις μετά την πώληση',
      Privacy: 'Προστασία προσωπικών δεδομένων',
      TermsOfUse: 'Όροι χρήσης',
      clear:'Εκκαθάριση',
      RefineBy: 'Περιορισμός κατά',
      placeholder: 'Εισαγωγή μοντέλου, ονόματος ή λέξης-κλειδιού',
      Favorites: 'Αγαπημένα',
      Compare: 'Σύγκριση',
      More: 'Περισσότερα',
      all: 'Όλα',
      enter: 'Εισαγωγή μοντέλου, ονόματος ή λέξης-κλειδιού',
      collapse: 'Σύμπτυξη',
      expand: 'Ανάπτυξη',
      confirm:'Επιβεβαίωση',
      cancel:'Άκυρο',
      channel:'Κανάλι',
    },
    login: {
      title: 'Είσοδος με αναγνωριστικό χρήστη',
      email: 'Email',
      pwd: 'Κωδικός πρόσβασης',
      changePwd: 'Αλλαγή κωδικού πρόσβασης',
      forgetPwd: 'Ξεχάσατε τον κωδικό πρόσβασης',
      register: 'Εγγραφή',
      rulesEmail: 'Το email δεν είναι έγκυρο',
    },
    //导航栏
    navbar: {
      aboutTitle: 'ΣΧΕΤΙΚΑ',
      about: 'ΣΧΕΤΙΚΑ ΜΕ ΤΗ HOLOWITS',
      products: 'ΠΡΟΪΌΝΤΑ',
      productCenter: 'ΚΈΝΤΡΟ ΠΡΟΪΌΝΤΩΝ',
      technicalSupport: 'ΥΠΟΣΤΉΡΙΞΗ',
      FAQ:'ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ',
      solution: 'ΛΥΣΗ',
      documentation: 'Τεκμηρίωση',
      support: 'ΥΠΟΣΤΉΡΙΞΗ',
      certificate: 'Πιστοποιητικό',
      pocDemo: 'Επίδειξη PoC',
      news: 'ΑΊΘΟΥΣΑ ΣΎΝΤΑΞΗΣ',
      events:'ΕΚΔΗΛΩΣΕΙΣ',
      tools: 'ΕΡΓΑΛΕΊΑ',
      partners: 'ΣΥΝΕΡΓΆΤΕΣ',
      resources: 'ΠΌΡΟΙ',
      forPartners: 'ΓΙΑ ΤΟΥΣ ΣΥΝΕΡΓΆΤΕΣ',
      forCustomers: 'ΓΙΑ ΤΟΥΣ ΠΕΛΑΤΕΣ',
      channel:'ΓΙΑ ΤΟΥΣ ΠΕΛΑΤΕΣ',
      videoLibrary: "BΊΝΤΕΟ",
      contact: "ΕΠΙΚΟΙΝΩΝΉΣΤΕ ΜΑΖΊ ΜΑΣ",
      algorithmstore: "ΚΑΤΑΣΤΗΜΑ ΑΛΓΟΡΙΘΜΩΝ",
      terms: "ΠΟΛΙΤΙΚΕΣ, ΟΡΟΙ, ΠΡΟΫΠΟΘΕΣΕΙΣ",
      warrantypolicy: "ΠΟΛΙΤΙΚΗ ΕΓΓΥΗΣΗΣ"
    },
    home: {
      'whatIsNew': "Τι νέο υπάρχει",
      'ProductSpotlight': 'Κύρια σημεία προϊόντος',
      'Events&News': 'Εκδηλώσεις & Νέα',
      'learnMore': 'Μάθετε περισσότερα'
    },
    //合作伙伴
    partners:{
      banner:{
        title:'Πιστοποίηση HOLOWITS',
        summery:'Intelligent Vision Specialist',
      },
      introduction:{
        title:'Εισαγωγή στα ηλεκτρονικά μαθήματα',
        desc:'Αυτό το μάθημα παρουσιάζει μια πλήρη σειρά καμερών της HOLOWITS οριζόμενων από λογισμικό (software-defined camera, SDC), καταγραφέων βίντεο δικτύου (network video recorder, NVR), έξυπνων συσκευών Micro Edge και λύσεων, ενώ σας παρέχει διάφορα εκπαιδευτικά υλικά και εξετάσεις που καλύπτουν απαραίτητες γνώσεις για τις δραστηριότητες πριν από την πώληση και μετά την πώληση. Μπορείτε να αποκτήσετε το πιστοποιητικό Intelligent Vision Specialist με την πιστοποίηση της HOLOWITS μετά την επιτυχή ολοκλήρωση των εξετάσεων.',
      },
      course:{
        title:'Η αξία του μαθήματος',
        value:'Αυτό το μάθημα θα σας βοηθήσει να ενημερωθείτε σχετικά με τα κυριότερα σημεία των προϊόντων και των λύσεων της HOLOWITS, να αποκτήσετε δεξιότητες που χρειάζεστε είτε πριν από την πώληση είτε για να παρέχετε στους πελάτες επαγγελματικές υπηρεσίες μετά την πώληση',
      },
      certification:{
        title:'Η αξία της πιστοποίησης',
        value:'Αυτό το πιστοποιητικό μπορεί να σας δώσει ανταγωνιστικά πλεονεκτήματα στην αγορά, να αναδείξει την εμπειρία σας στα προϊόντα της HOLOWITS, στις λύσεις, και στις υπηρεσίες μετά την πώληση, και να επιτρέψει στους πελάτες και στους εργοδότες να εντοπίσουν εύκολα τις επαγγελματικές σας ικανότητές.',
      },
      contents:[
        {text: 'Κύριες τεχνικές διαφάνειες κάμερας SDC της HOLOWITS'},
        {text: 'Κύριες τεχνικές διαφάνειες έξυπνων συσκευών Micro Edge της HOLOWITS'},
        {text: 'Κύριες τεχνικές διαφάνειες της συσκευής HWT-NVR800 της HOLOWITS'},
        {text: 'Οδηγός παραμετροποίησης παρελκομένων HOLOWITS'},
        {text: 'Λύση έξυπνης λιανικής πώλησης HOLOWITS'},
        {text: 'Λύση έξυπνης πανεπιστημιούπολης HOLOWITS'},
        {text: 'Λύση έξυπνου δικτύου HOLOWITS'},
        {text: 'Λύση έξυπνων μεταφορών HOLOWITS'},
        {text: 'Γρήγορος οδηγός για την έρευνα πεδίου και τη θέση σε λειτουργία της κάμερας αποτύπωσης στόχου'},
        {text: 'Γρήγορος οδηγός για την έρευνα πεδίου και τη θέση σε λειτουργία της κάμερας ePolice'},
        {text: 'Εγκατάσταση και θέση σε λειτουργία της συσκευής HWT-NVR800 της HOLOWITS'},
        {text: 'Εγκατάσταση και θέση σε λειτουργία της συσκευής HWT-IVS1800 της HOLOWITS'},
        {text: 'Παρουσίαση κάμερας της σειράς A και XVR'},
        {text: 'Εγχειρίδιο χρήσης της εφαρμογής HOLOWITS'},
        {text: 'Παρουσίαση κάμερας της σειράς Ε'},
      ],
      learningGuide:{
        title:'Οδηγός εκμάθησης',
        desc:'Για να περάσετε τις εξετάσεις, θα πρέπει να μελετήσετε σχολαστικά το σχετικό υλικό και τα βίντεο. Μετά την απόκτηση της πιστοποίησης, το πιστοποιητικό πρέπει να ενημερώνεται κάθε δύο χρόνια.',
        text:'Απαιτείται εγγραφή για την πρώτη σύνδεση',
        registerCode:'Κωδικός εγγραφής: ',
        registerValue:'UJIQ-RVH-PQW',
        btnValue:'Έναρξη εκμάθησης',
      },
    },
    //关于Holowits
    aboutHWT:{
      title:'Σχετικά με τη HOLOWITS',
      desc:'Η HOLOWITS είναι ένας παγκόσμιος προμηθευτής έξυπνων προϊόντων και λύσεων Διαδικτύου των πραγμάτων (IoT) που βασίζονται σε τεχνολογίες πολυδιάστατης πληροφόρησης και ενσωματώνουν ένα ευρύ φάσμα δυνατοτήτων όπως η έρευνα και ανάπτυξη, η παραγωγή, η διανομή, οι πωλήσεις και οι ικανότητες παροχής υπηρεσιών. Η HOLOWITS διαθέτει τεχνολογίες έξυπνης όρασης, μια πλήρη βιομηχανική αλυσίδα και ισχυρές ικανότητες τεχνικής υποστήριξης. Ανταποκρινόμενη στη συνεχώς αυξανόμενη παγκόσμια ζήτηση για οπτική νοημοσύνη, η HOLOWITS είναι προσηλωμένη στην ανάπτυξη καμερών AI οριζόμενων από λογισμικό (SDC), λύσεων έξυπνης αποθήκευσης βίντεο και υπολογιστικών πλατφορμών, καθώς και στην παροχή υπηρεσιών cloud. Αυτές οι προσφορές μπορούν να εφαρμοστούν σε μια ευρεία ποικιλία σεναρίων όπως η έξυπνη πόλη, οι έξυπνες μεταφορές, η έξυπνη ενέργεια, η έξυπνη κατασκευή, η έξυπνη πανεπιστημιούπολη και η έξυπνη λιανική πώληση. Στόχος μας είναι να συνεργαστούμε για να οικοδομήσουμε έναν έξυπνο κόσμο όπου τα πάντα αισθάνονται. Για να το επιτύχουμε αυτό, είμαστε αφοσιωμένοι στην παροχή ασφαλών, αξιόπιστων, εύχρηστων και εξαιρετικών προϊόντων και λύσεων στην παγκόσμια αγορά.',
    },
    // 产品中心
    products: {
      productTypes: 'Τύπος προϊόντος',
      sort: 'Ταξινόμηση',
      overAll: 'Συνολικά',
      hot: 'Δημοφιλή',
      latest: 'Νέα',
      listPrice: 'Τιμοκατάλογος',
      preSales: 'Προ της πώλησης',
      model: 'Μοντέλο',
      processor: 'Επεξεργαστής',
      memory: 'Μνήμη',
      computingPower: 'Υπολογισμός',
      series: '',
      form: ''
    },
    // 产品详情
    productDetail: {
      productDetail: 'Λεπτομέρειες',
      accessoryDetail: 'Λεπτομέρειες παρελκομένων',
      specifications: 'Προδιαγραφές',
      certification: 'Πιστοποίηση',
      introduction: 'Εισαγωγή',
      download: 'Λήψη',
      documentation: 'Τεκμηρίωση',
      huaweiCcsc: 'imgs/product_detail/mapen.png',
      clickHere: 'Κάντε κλικ εδώ',
      dataSheet: 'Φύλλο δεδομένων',
      afterSalesDocuments: 'Έγγραφα για μετά την πώληση',
      copy: 'Αντιγραφή',
      reportError: 'Αναφορά σφάλματος',
      description: 'Περιγραφή',
      describeError: 'Περιγράψτε το σφάλμα που εντοπίσατε.',
      picture: 'Εικόνα',
      onlyJpg: 'Μόνο η μορφή .jpg υποστηρίζεται.',
      attachment: 'Συνημμένο',
      selectFile: 'Επιλογή αρχείου',
      anonymous: 'Ανώνυμα',
      submit: 'Υποβολή',
      accessory: 'Παρελκόμενο',
      technicalSpec: 'Τεχνική προδιαγραφή',
      dimensions: 'Διαστάσεις',
      remarks: 'Παρατηρήσεις',
      optionalFitting: 'Προαιρετικό εξάρτημα',
      favorites: 'Αγαπημένο',
      keySpec: 'Βασική προδιαγραφή',
      viewAll: 'Σύνδεση για προβολή όλων',
      clicktoLoad: 'Κάντε κλικ εδώ για λήψη',
      completeSpecificationList: 'Πλήρης λίστα προδιαγραφών',
    },
    // 技术支持
    support: {
      wahtDoYouNeedHelpWith: 'Σε τι χρειάζεστε βοήθεια;',
      title: 'Καλώς ήρθατε στην τεχνική υποστήριξη της HOLOWITS',
      explain: 'Η τεχνική υποστήριξη της HOLOWITS παρέχει κορυφαία υποστήριξη για τα προϊόντα και τις λύσεις της HOLOWITS. Οι ηλεκτρονικές υπηρεσίες υποστήριξης και οι μηχανικοί μας σε όλο τον κόσμο είναι έτοιμοι να σας βοηθήσουν ανά πάσα στιγμή, οπουδήποτε.',
      documentation: 'Τεκμηρίωση',
      softwareDownload: 'Λήψη λογισμικού',
      video: 'Βίντεο',
      searchPlaceholder: 'Εισαγωγή λέξης-κλειδιού',
    },
    contact: {
      theme: 'Χρειάζεστε τεχνική υποστήριξη;',
      content: 'Σας συμβουλεύουμε να επικοινωνήσετε με τον αρμόδιο διανομέα της HOLOWITS στη χώρα ή την περιοχή σας για τεχνική υποστήριξη.',
      tip1: 'Για να επικοινωνήσετε με τους διανομείς και τους μεταπωλητές της HOLOWITS',
      tip2: 'Για να επικοινωνήσετε με τη HOLOWITS, στείλτε email στη διεύθυνση',
      button1: 'Κάντε κλικ εδώ',
      button2: 'support@holowits.com',
      title: '',
      explain: ''
    },
      // 渠道中心
    channel: {
      partnerName: 'Όνομα συνεργάτη',
      countryOrRegion: 'Χώρα/περιοχή',
      partnerType: 'Τύπος συνεργάτη',
      searchPlaceholder:'Αναζήτηση στη λίστα συνεργατών',
      website: 'Ιστότοπος',
      email: 'Email',
      phone: 'Τηλέφωνο',
      address: 'Διεύθυνση'
    },
    // 新闻中心
    news: {
      searchPlaceholder: 'Εισαγωγή λέξης-κλειδιού',
      search: 'Αναζήτηση',
    },
    // 安防工具
    securityTools: {
      cameradetectionDistance: 'Υπολογισμός απόστασης ανίχνευσης κάμερας',
      disable: 'Απενεργοποίηση',
      enable: 'Ενεργοποίηση',
      videoResolution: 'Ανάλυση βίντεο',
      encodingBitRate: 'Κωδικοποίηση ρυθμού μετάδοσης bit',
      NumberOfNVRs: 'Πλήθος NVR',
      NumberOfSDCs: 'Πλήθος SDC',
      microCheckpoint: 'Σημείο ελέγχου micro',
      ePoliceCheckpoint: 'ePolice/Σημείο ελέγχου',
      targetDetection: 'Ανίχνευση/αναγνώριση στόχου',
      calculateBandwidth: 'Υπολογισμός εύρους ζώνης',
      calculateRc: 'Υπολογισμός ικανότητας καταγραφής',
      NVRAccess: 'Πρόσβαση NVR',
      ipTools: 'Εργαλείο σχεδίασης συστήματος βίντεο IP',
      //提示信息
      microResolutionTips: 'Στη λειτουργία σημείου ελέγχου micro, συνιστάται η ανάλυση της πινακίδας κυκλοφορίας να είναι τουλάχιστον 80 pixel.',
      microInstallationTips: 'Στα σενάρια λωρίδων, συνιστάται το ύψος της εγκατάστασης να κυμαίνεται από 4,5 έως 6 m. Στις εισόδους και στις εξόδους της πανεπιστημιούπολης, συνιστάται το ύψος της εγκατάστασης να κυμαίνεται από 1,3 έως 1,5 m. Μπορείτε να ρυθμίσετε το ύψος της εγκατάστασης βάσει των απαιτήσεων της τοποθεσίας.',
      ePoliceResolutionTips: 'Στη λειτουργία ePolice, η ανάλυση της πινακίδας κυκλοφορίας πρέπει να είναι μεγαλύτερη ή ίση με 100 pixel. Στη λειτουργία σημείου ελέγχου, εάν πρέπει να αποτυπωθούν μόνο πινακίδες κυκλοφορίας, η ανάλυση της πινακίδας κυκλοφορίας πρέπει να είναι μεγαλύτερη ή ίση με 100 pixel. Εάν πρέπει επίσης να αποτυπωθούν στόχοι εντός των οχημάτων, η ανάλυση της πινακίδας κυκλοφορίας πρέπει να είναι μεγαλύτερη ή ίση με 180 pixel. ',
      ePoliceInstallationTips: 'Το συνιστώμενο ύψος εγκατάστασης κυμαίνεται από 5,5 m έως 6,5 m.',
      targetResolutionTips: 'Ανίχνευση στόχου: For short-focus (less than 12 mm) cameras, the recommended target resolution is at least 80 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels. Target recognition": For short-focus (less than 12 mm) cameras, the recommended target recognition is at least 110 pixels. For medium- and long-focus (12 mm or more) cameras, the recommended target resolution is at least 120 pixels.',
      targetInstallationTips: 'Ανίχνευση στόχου: For cameras with a fixed focal length of 2.8 mm or 3.6 mm, the recommended installation height ranges from 2 m to 2.5 m. For cameras with a fixed focal length of 6 mm, the recommended installation height ranges from 2 m to 3 m. For cameras with other focal lengths, the recommended installation height ranges from 2.5 m to 3.5 m. Target recognition": For short-focus cameras, the recommended installation height ranges from 2.5 m to 3 m. For long-focus cameras, the recommended installation height ranges from 2.5 m to 3.5 m.',
    },
  
    // 提示信息
    tipInfo: {
      exportFailure: 'Αποτυχία εξαγωγής.',
      addProToComp: 'Προσθέστε προϊόν για σύγκριση.',
      selectLeastTwo: 'Επιλέξτε τουλάχιστον δύο προϊόντα για σύγκριση.',
      selectMaximum: 'Μπορείτε να επιλέξετε έως τέσσερα προϊόντα για σύγκριση.',
      copySuccess: 'Επιτυχία αντιγραφής.',
      noData: 'Δεν υπάρχουν δεδομένα.',
      selectOther: 'Η επιλεγμένη συσκευή δεν διαθέτει δεδομένα. Επιλέξτε άλλη συσκευή.',
      onlyJpg: 'Μόνο εικόνες JPG υποστηρίζονται.',
      exeNoUpload: 'Δεν είναι δυνατή η αποστολή αρχείων EXE.',
      problemNotEmpty: 'Η περιγραφή του προβλήματος δεν μπορεί να είναι κενή.',
      submitSuccess: 'Η υποβολή ήταν επιτυχής.',
      submitFailed: 'Η υποβολή απέτυχε. Προσπαθήστε ξανά αργότερα.',
      loginSuccess: 'Επιτυχία σύνδεσης',
      errorPwd:'Οι δύο κωδικοί πρόσβασης δεν συμφωνούν',
      confirmLogout:'Επιβεβαίωση εξόδου από τον τρέχοντα λογαριασμό;',
      tooManyRequest:'Η λήψη του κωδικού ελέγχου ταυτότητας επαναλαμβάνεται πολύ συχνά. Προσπαθήστε ξανά σε 3 λεπτά',
      getCodeImageFailed:'Αποτυχία λήψης κωδικού επαλήθευσης εικόνας',
    },
    technologySupport: {
      support: 'Υποστήριξη',
    },
    // 文档中心
    documentation: {
      searchPlaceholder: 'Εισαγωγή της λέξης-κλειδιού',
      search: 'Αναζήτηση',
      productFilter: 'Προϊόν',
      typeFilter: 'Τύπος',
      languageFilter: 'Γλώσσα',
      formatFilter: 'Μορφή',
      publishDate: 'Ταξινόμηση κατά ημερομηνία κυκλοφορίας',
      downloadTimes: 'Ταξινόμηση κατά αριθμό λήψεων',
      hotDoc: 'Δημοφιλές έγγραφο',
      result: 'Αποτέλεσμα',
      download: 'Λήψη',
      batDownload: 'Μαζική λήψη',
      checkAll: 'Έλεγχος όλων',
      paginalNumber: 'Αριθμός σελίδας',
    },
    // 视频中心
    videoLibrary: {
      title: 'Βιβλιοθήκη βίντεο',
      searchVideo: 'Αναζήτηση βίντεο',
      all: 'Όλα',
      branding: 'Εμπορική προσαρμογή',
      products: 'Προϊόντα',
      solutions: 'Λύσεις',
      technicalSupport: 'Τεχνική υποστήριξη',
      training: 'Κατάρτιση',
      hOLOWITSClub: 'Λέσχη HOLOWITS',
      algorithm: 'Αλγόριθμος',
      technologies: 'Τεχνολογίες'
    },
    faq: {
      faq: 'ΣΥΧΝΕΣ ΕΡΩΤΗΣΕΙΣ',
      Products: 'Προϊόντα',
      Solutions: 'Λύσεις',
      Partners: 'Συνεργάτες',
      Marketing: 'Μάρκετινγκ',
      Others: 'Άλλα',
      placeholder: 'αφήστε κενό και θα λάβετε όλες τις συχνές ερωτήσεις',
      help: 'Τρόπος χρήσης της αναζήτησης στις συχνές ερωτήσεις'
    },
    learnRegister: {
      pageTitle: "Εγγραφή στις εξετάσεις HOLOWITS Certified Specialist",
      pageDesc1: "Συμπληρώστε το παρακάτω έντυπο.",
      pageDesc2: "Μετά την επαλήθευση, θα σας αποστείλουμε email .",
      hint1: "Αποδείξτε ότι είστε υπάλληλος της εταιρείας σας (μπορείτε να αποστείλετε την κάρτα εργαζομένου ή την επαγγελματική σας κάρτα)",
      hint2: "Αποστείλετε την άδεια της εταιρείας σας",
      required: "Αυτό το πεδίο είναι απαιτούμενο.",
      upload: "αποστολή",
      successPanelTitle: "Επιτυχία υποβολής",
      successPanelText: "Η αίτηση έχει υποβληθεί και ο διαχειριστής θα επικοινωνήσει μαζί σας μέσω email.\nΕάν η εταιρεία σας θέλει να γίνει πιστοποιημένος συνεργάτης μας επιπέδου 2, κάντε κλικ εδώ για να εγγραφείτε. Αφού ένας υπάλληλος της εταιρείας σας περάσει τις εξετάσεις HOLOWITS Certified Specialist, η εταιρεία σας μπορεί να γίνει πιστοποιημένος συνεργάτης μας επιπέδου 2 και επίσης μπορεί να εμφανίζεται στον ιστότοπό μας.",
      inputPlaceholder: "Περιγράψτε συνοπτικά γιατί δίνετε τις εξετάσεις HOLOWITS specialist"
    },
    register: {
      register: "Εγγραφή",
      email: "Email",
      companyName: "Επωνυμία εταιρείας (Όλα τα γράμματα πρέπει να είναι κεφαλαία)",
      name: "Το όνομά σας",
      country: "Χώρα/περιοχή",
      description: "Περιγράψτε τη σχέση που έχετε εσείς ή η εταιρεία σας με τη HOLOWITS",
      code: "Κωδικός επαλήθευσης",
      cancel: "Άκυρο",
      submit: "Υποβολή",
      successPanelTitle: "Επιτυχία υποβολής",
      successPanelText: "Η αίτηση έχει υποβληθεί και ο διαχειριστής θα επικοινωνήσει μαζί σας μέσω email.",
      back: "Πίσω",
      rules: {
        email: "Το email δεν μπορεί να είναι κενό.",
        companyName: "Το όνομα δεν μπορεί να είναι κενό.",
        name: "Το όνομα δεν μπορεί να είναι κενό.",
        country: "Η χώρα ή η περιοχή δεν μπορεί να είναι κενή.",
        description: "η περιγραφή δεν μπορεί να είναι κενή.",
        code: "ο κωδικός δεν μπορεί να είναι κενός."
      }
    },
    reseller: {
      pageTitle: "ΓΙΝΕΤΕ ΣΥΝΕΡΓΑΤΗΣ ΕΠΙΠΕΔΟΥ 2",
      companyName: "Επωνυμία εταιρείας",
      webSite: "Διεύθυνση URL επίσημης ιστοσελίδας",
      region: "Περιοχή",
      coopCountry: "Χώρα/περιοχή",
      preSales: "Email για υποστήριξη προ της πώλησης",
      postSales: "Email για υποστήριξη μετά την πώληση",
      marketing: "Email για υποστήριξη μάρκετινγκ",
      email: "Email για να επικοινωνήσουμε μαζί σας",
      companyEmail: "Email για να εγγραφείτε με τον λογαριασμό της εταιρείας σας",
      phone: "Τηλεφωνικός αριθμός για υποστήριξη προ της πώλησης",
      address: "Διεύθυνση εταιρείας",
      partnerType: "Τύπος συνεργάτη",
      uploadLog: "Αποστείλτε ένα γραφικό υψηλής ανάλυσης με το λογότυπο της εταιρείας σας (jpg. ή png.)",
      upload: "Αποστολή",
      downlaod: "Λήψη προτύπου συμφωνίας",
      businessLicense: "Αποστείλτε την άδεια λειτουργίας της εταιρείας σας (Αρχείο μεγαλύτερο από 50M) (Υποστηρίζεται μορφή pdf. png. jpg. jpeg. webp.)",
      agreeFieldText: "Εξουσιοδοτώ τη HOLOWITS να καταχωρίσει την εταιρεία μου στους ιστότοπους της HOLOWITS.",
      successPanelTitle: "Επιτυχία υποβολής",
      successPanelText: "Η αίτηση έχει υποβληθεί και ο διαχειριστής θα επικοινωνήσει μαζί σας μέσω email.",
    },
    contactUs: {
      contactUsPricingInfo:'Επικοινωνήστε μαζί μας Πληροφορίες τιμολόγησης',
      contactUs: 'Επικοινωνήστε μαζί μας',
      options: {
        pricingInfo: 'Πληροφορίες/τιμολόγησης',
        serviceRequests: 'Αιτήματα εξυπηρέτησης',
      },
      pricingInfo: {
        Title: 'Επικοινωνήστε μαζί μας',
        Desc1: 'Συμπληρώστε το παρακάτω έντυπο.',
        Desc2: 'Θα επικοινωνήσουμε μαζί σας σύντομα.',
        Mandatory: 'Υποχρεωτικό',
        FirstName: 'Όνομα',
        LastName: 'Επώνυμο',
        Email: 'Email',
        Telephone: 'Τηλέφωνο',
        CountryRegion: 'Χώρα/περιοχή',
        Partner: 'Συνεργάτης',
        Company: 'Εταιρεία',
        Industry: 'Κλάδος',
        JobTitle: 'Τίτλος θέσης εργασίας',
        FavoriteProducts: 'Αγαπημένα προϊόντα',
        Budget: 'Προϋπολογισμός',
        BrieflyPlaceholder: 'Περιγράψτε συνοπτικά τις απαιτήσεις του έργου σας. ',
        ConfirmText: 'Συμφωνώ να λαμβάνω πληροφορίες σχετικά με προϊόντα, λύσεις, υπηρεσίες και προσφορές από τη HOLOWITS και από εξουσιοδοτημένους συνεργάτες της HOLOWITS. Κατανοώ ότι μπορώ να καταργήσω την εγγραφή μου ανά πάσα στιγμή.',
        Yes: 'Ναι',
        No: 'Όχι',
        AgreeText: 'Κατανοώ και συμφωνώ με τη χρήση και τη μεταφορά των προσωπικών μου στοιχείων από τη HOLOWITS σύμφωνα με τη HOLOWITS’ ',
        PrivacyPolicy: 'Πολιτική προστασίας προσωπικών δεδομένων',
        publictiy: 'Αφού ένας υπάλληλος της εταιρείας σας περάσει τις εξετάσεις HOLOWITS Certified Specialist, η εταιρεία σας μπορεί να γίνει πιστοποιημένος συνεργάτης μας επιπέδου 2 και επίσης μπορεί να εμφανίζεται στον ιστότοπό μας.',
        TermsOfUse: 'Όροι χρήσης',
        And: 'και',
        placeholder: 'Είσοδος δεδομένων',
        submit: 'Υποβολή',
        fieldRequired: 'Αυτό το πεδίο είναι απαιτούμενο.',
        emailValidator: {
          'at-error': 'Μια διεύθυνση email πρέπει να περιέχει ένα &quot;@&quot; σύμβολο.',
          'account-letter-forbidden': 'Το όνομα του email (παράδειγμα: Adam.Smith@abc.com) contains invalid characters.',
          'prevDot-error': 'Το όνομα του email (παράδειγμα: Adam.Smith@abc.com) must not start or end with a dot or period (".").',
          'double-dot-error:': 'Two successive dots or periods (".") together is invalid.',
          'domain-error': 'Ο τομέας (παράδειγμα: Adam.Smith@abc.com) must contain at least one domain name.',
          'length-error': 'Μια διεύθυνση email δεν πρέπει να υπερβαίνει τους 254 χαρακτήρες.',
          'nextLetter-forbidden': 'Ο τομέας (παράδειγμα: Adam.Smith@abc.com) contains invalid characters.',
          'nextLine-error': 'Ο τομέας (παράδειγμα: Adam.Smith@abc.com) must not start or end with a hyphen ("-").',
          'account-length-error': 'Ένα όνομα email (παράδειγμα: Adam.Smith@abc.com) must not exceed 63 characters.',
        },
        phoneFormatError: 'Παράδειγμα : Area Code(3-6 DIGITALS, eg.0066)Phone Number'
      },
    },
    algorithm: {
      pageTitle: "Κατάστημα αλγορίθμων HOLOWITS",
      navOptionTag: "Έξυπνος αλγόριθμος",
      recommendation: "Πρόταση σχετικών προϊόντων",
      selectorItemTitle: {
       "Product Application Scenario": "Σενάριο εφαρμογής προϊόντος",
       "Algorithm Classification": "Ταξινόμηση αλγορίθμων",
       "Applicable Platform": "Εφαρμοστέα πλατφόρμα",
       "Algorithm type": "Τύπος αλγορίθμου"
      },
      tag: {
       "All": "Όλα",
       "Transportation": "Μεταφορές",
       "Government": "Διακυβέρνηση",
       "Finance": "Οικονομικά",
       "Energy": "Ενέργεια",
       "Public Security": "Δημόσια ασφάλεια",
       "Personnel Detection": "Ανίχνευση προσωπικού",
       "Intelligent Transportation": "Έξυπνες μεταφορές",
       "Text Detection": "Ανίχνευση κειμένου",
       "Behavior Analysis": "Ανάλυση συμπεριφοράς",
       "Voice Detection": "Ανίχνευση φωνής",
       "Video Analysis": "Ανάλυση βίντεο",
       "Perimeter Events": "Περιμετρικά συμβάντα",
       "Event Detection": "Ανίχνευση συμβάντων",
       "Object Detection": "Ανίχνευση αντικειμένου",
       "Detection Analysis": "Ανάλυση ανίχνευσης",
       "SDC": "SDC",
       "HWT-IVS1800": "HWT-IVS1800",
       "HOLOWITS": "HOLOWITS",
       "HOLOWITS SELECTED": "ΕΠΙΛΟΓΕΣ HOLOWITS",
       "OTHER": "ΑΛΛΟ"
      },
      label: {
       "Subway": "Μετρό",
       "Highway": "Αυτοκινητόδρομος",
       "Railway": "Σιδηρόδρομος",
       "Airport": "Αεροδρόμιο",
       "Public Transport": "Δημόσιες μεταφορές",
       "Digital Government": "Ψηφιακή διακυβέρνηση",
       "Bank": "Τράπεζα",
       "Insurance": "Ασφάλιση",
       "Wind Power": "Αιολική ενέργεια",
       "Solar Energy": "Ηλιακή ενέργεια",
       "Electric Power": "Ηλεκτρική ενέργεια",
       "Gas": "Αέριο",
       "Water Conservancy": "Εξοικονόμηση νερού",
       "Petroleum": "Πετρέλαιο",
       "Forest": "Δάσος",
       "City Management": "Διαχείριση πόλης",
       "Fire Detection": "Ανίχνευση πυρκαγιάς",
       "Manufacturing": "Παραγωγή",
       "Agriculture": "Γεωργία",
       "Retail": "Λιανική πώληση",
       "Logistics": "Υλικοτεχνική υποστήριξη",
       "Service": "Εξυπηρέτηση",
       "Medical Treatment": "Ιατρική περίθαλψη",
       "Catering Industry": "Κλάδος τροφοδοσίας",
       "Tourism": "Τουρισμός",
       "Education": "Εκπαίδευση",
       "Campus": "Πανεπιστημιούπολη",
       "Family": "Οικογένεια",
       "Internet of Things(IoT)": "Διαδίκτυο των πραγμάτων (IoT)",
       "Target Recognition": "Αναγνώριση στόχου",
       "Personnel Attribute Analysis": "Ανάλυση χαρακτηριστικών προσωπικού",
       "Overall Target Detection": "Συνολική ανίχνευση στόχου",
       "License Plate detection": "Ανίχνευση πινακίδας κυκλοφορίας",
       "Vehicle Attribute Detection": "Ανίχνευση χαρακτηριστικών οχήματος",
       "Non-standard Vehicle Inspection": "Μη τυπική επιθεώρηση οχήματος",
       "Illegal Detection": "Παράνομη ανίχνευση",
       "Vehicle Detection": "Ανίχνευση οχήματος",
       "Omni-data Structuring": "Διάρθρωση όλων των δεδομένων",
       "OCR": "OCR",
       "Regulation Breach Detection": "Ανίχνευση παραβίασης κανονισμού",
       "Crowd Analysis": "Ανάλυση πλήθους",
       "Voice Synthesis": "Σύνθεση φωνής",
       "Voice Identification": "Αναγνώριση φωνής",
       "Video Abstract": "Απόσπασμα βίντεο",
       "Perimeter Intrusion": "Περιμετρική εισβολή",
       "Water Pollution Detection": "Ανίχνευση ρύπανσης των υδάτων",
       "Carrying Dangerous Objects": "Μεταφορά επικίνδυνων αντικειμένων",
       "Carrying Prohibited Items": "Μεταφορά απαγορευμένων αντικειμένων",
       "Construction Machinery Detection": "Ανίχνευση μηχανημάτων κατασκευών",
       "Foreign Matter Detection": "Ανίχνευση ξένης ύλης",
       "Wearing Detection": "Ανίχνευση φθοράς",
       "Equipment Status Detection": "Ανίχνευση κατάστασης εξοπλισμού",
       "Instrumentation Detection": "Ανίχνευση οργάνων",
       "Defect Detection": "Ανίχνευση ελαττωμάτων",
       "Remote Sensing": "Απομακρυσμένος εντοπισμός",
       "Robot": "Ρομπότ",
       "X Series": "Σειρά X",
       "M Series": "Σειρά M",
       "C Series": "Σειρά C",
       "D Series": "Σειρά D",
       "HWT-IVS1800": "HWT-IVS1800",
       "Incidents Detection": "Ανίχνευση περιστατικών",
       "HOLOWITS": "HOLOWITS",
       "HOLOWITS SELECTED": "ΕΠΙΛΟΓΕΣ HOLOWITS",
       "OTHER": "ΑΛΛΟ",
       "Vehicle Detection": "Ανίχνευση οχήματος",
       "Video Synopsis": "Σύνοψη βίντεο",
      },
      details: {
        "update tips": "Μη διαθέσιμο, περιμένετε την ενημέρωση.",
        "Service Provider": "Πάροχος υπηρεσιών",
        "To contact service provider": "Για να επικοινωνήσετε με τον πάροχο υπηρεσιών",
        "Service Provider Profile": "Προφίλ παρόχου υπηρεσιών",
        "tips": "Οι περιγραφές στη σελίδα παρέχονται από τους παρόχους υπηρεσιών με βάση τα αποτελέσματα των δοκιμών τους. Τα πραγματικά αποτελέσματα ενδέχεται να διαφέρουν ανάλογα με τα σενάρια εφαρμογής. Για λεπτομέρειες σχετικά με τις ολοκληρωμένες δυνατότητες του προϊόντος, επικοινωνήστε με την ομάδα λειτουργίας του καταστήματος.",
        "tags": {
          "Product Details": "Λεπτομέρειες προϊόντος",
          "Associated Product": "Σχετικό προϊόν",
          "Customer Case": "Περίπτωση πελάτη",
          "Customer Evaluation": "Αξιολόγηση πελατών",
          "Support": "Υποστήριξη"
        },
        smallTags: {
          "Parameters": "Παράμετροι",
          "Introduction": "Εισαγωγή",
          "Version": "Έκδοση",
          "Highlights": "Κύρια σημεία",
          "Scenario Requirements": "Απαιτήσεις σεναρίου",
          "Graphic presentation": "Γραφική παρουσίαση",
          "Solution with this algorithm": "Λύση με αυτόν τον αλγόριθμο",
          "Supporting Applications": "Εφαρμογές υποστήριξης",
          "User Manual": "Οδηγίες χρήσης"
        }
      }
     }
  };  